import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import BigNewsBox from "../components/BigNewsBox"
import SmallNewsBox from "../components/SmallNewsBox"
import OtherNews from "../components/OtherNews"
import InterestingArticle from "../components/InterestingArticle"
import HashTags from "../components/HashTags"
import styled from "styled-components"
import EmptyWarning from "../components/EmptyWarning"
import AmosovaBigTopBanner from "../components/ads/AmosovaBigTopBanner"
import AmosovaLeftBanner from "../components/ads/AmosovaLeftBanner"

const IndexPage = ({ data }) => {
  const posts = data.allSanityPost.nodes
  const postsSmallNews = data.sanityDedicatedArticles.listDedicatedArticles
  const tinyListNews = data.tinylist.nodes
  return (
    <Layout>
      <Seo title={data.sanityHome.title || `Домой`} />
      {data.sanityAdBanner.positions.topBar && <AmosovaBigTopBanner />}
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-4 gap-5">
          <div className="col-span-4 md:col-span-4 lg:col-span-2 row-span-4">
            {posts.map(post => (
              <BigNewsBox
                key={post.id}
                themeColor={post.categories.color}
                title={post.title}
                category={post.categories.title}
                categoryLink={post.categories.slug.current}
                subcategory={post.subcategory}
                publishDay={post.publishedAt}
                link={post.slug.current}
                text={post._rawExcerpt}
                image={post._rawMainImage}
              />
            ))}
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 row-span-4">
            {postsSmallNews.map((postSmallNews, index) => (
              <SmallNewsBox
                key={index}
                themeColor={postSmallNews.categories.color}
                title={postSmallNews.title}
                categoryLink={postSmallNews.categories.slug.current}
                subcategory={postSmallNews.subcategory}
                category={postSmallNews.categories.title}
                link={postSmallNews.slug.current}
                image={postSmallNews._rawMainImage}
              />
            ))}
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 row-span-4">
            {/* {data.sanityAdBanner.positions.leftBar && <AmosovaLeftBanner />} */}
            <AmosovaLeftBanner />
            <div className="">
              <div className="relative" style={{ height: "60px" }}>
                <CategoryBar className="bg-fb-blue rounded-none md:rounded flex items-center pl-5 font-opensanscond category-bar inherit md:absolute">
                  Лента новостей
                </CategoryBar>
              </div>
              <div className="divide-y divide-gray-300 px-3 pb-4 bg-fb-blue bg-opacity-5">
                {tinyListNews.length === 0 && <EmptyWarning />}
                {tinyListNews.map((tinyNews, index) => (
                  <OtherNews
                    as="div"
                    key={index}
                    themeColor={tinyNews.categories.color}
                    title={tinyNews.title}
                    category={tinyNews.categories.title}
                    categoryLink={tinyNews.categories.slug.current}
                    link={tinyNews.slug.current}
                  />
                ))}
              </div>
              <InterestingArticle />
              <HashTags />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    allSanityPost(sort: { fields: publishedAt, order: DESC }, limit: 3) {
      nodes {
        id
        slug {
          current
        }
        title
        categories {
          title
          slug {
            current
          }
          color
          description
        }
        publishedAt(formatString: "DD-MM-YYYY")
        subcategory
        _rawMainImage(resolveReferences: { maxDepth: 10 })
        _rawExcerpt(resolveReferences: { maxDepth: 10 })
      }
    }
    sanityHome {
      title
    }
    sanityDedicatedArticles(
      id: { eq: "-fdf4c74a-5719-5240-bf7d-437a5930df0d" }
    ) {
      listDedicatedArticles {
        id
        title
        _rawMainImage(resolveReferences: { maxDepth: 10 })
        slug {
          current
        }
        categories {
          title
          color
          slug {
            current
          }
        }
        subcategory
      }
    }
    tinylist: allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      skip: 3
      limit: 8
    ) {
      nodes {
        title
        categories {
          title
          slug {
            current
          }
          color
        }
        slug {
          current
        }
      }
    }
    sanityAdBanner(id: { eq: "-6025e2e7-5795-581f-97b5-7436c86dbe7b" }) {
      positions {
        leftBar
        topBar
      }
    }
  }
`
const CategoryBar = styled.div`
  bottom: 0px;
  right: 5px;
  width: 100%;
  height: 60px;
`
export default IndexPage
